// 1. Import the entire core Three.js library
import * as THREE_CORE from 'three';

// 2. Import the specific addons you need from the examples/jsm folder
//    (These paths match the standard three.js package structure)
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { GLTFExporter } from 'three/examples/jsm/exporters/GLTFExporter.js';
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js';

// 3. Create a new object that will become the global "THREE"
const THREE = { ...THREE_CORE };

// 4. Attach your addons to this object
THREE.GLTFLoader = GLTFLoader;
THREE.GLTFExporter = GLTFExporter;
THREE.RGBELoader = RGBELoader;

// 5. Export the final object. 
//    Rollup will assign this export to the global variable name defined in the config.
export default THREE;